import { z } from "zod";

// This coerces a boolean from a number / string to a bool
// This is helpful for Solana which stores bools as 0 / 1
export const CoerceBooleanZ = z.preprocess(
  (data) => Boolean(data),
  z.boolean(),
);

export const CoerceNumberZ = z.preprocess(
  (data) => (data != null ? Number(data) : data),
  z.number(),
);
